import { ErrorBoundary as ZenErrorBoundary } from '@zenbusiness/application-commons-logging';
import Empty from '@zenbusiness/zui/Empty';

function ErrorBoundary({ children, ...delegated }) {
  return (
    <ZenErrorBoundary
      fallback={<Empty />}
      resetOnLocationChange
      {...delegated}
    >
      {children}
    </ZenErrorBoundary>
  );
}

export default ErrorBoundary;
